import { createWebHistory, createRouter } from "vue-router";
import CandidateApply from "@/components/CandidateApply.vue";
//import axios from 'axios'
import NProgress from 'nprogress';

const routes = [
    {
        path: "/:dealership/:qrcode?",
        //alias: "/profile/:candidateguid",
        name: "CandidateApply",
        component: CandidateApply,
        meta: {
            requiresAuth: false
        }
    }
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

/*
router.beforeEach((to, from, next) => {
    if (to.name !== 'Login' && !isAuthenticated) next({ name: 'Login' })
    else next()
})
*/

router.beforeResolve((to, from, next) => {
    if (to.name) {
        NProgress.start()
    }
    next()
})

router.afterEach(() => {
    NProgress.done()
})

/*
router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        // check for valid auth token
        axios.get('/Home/CheckAuth').then(response => {
            // Token is valid, so continue
            if (response.data != null && response.data.success) {
                next();
            }
            else {
                window.location.href = "/Identity/Account/Login?ReturnUrl=/admin" + to.fullPath;
            }
        }).catch(() => {
            // There was an error so redirect
            window.location.href = "/Identity/Account/Login?ReturnUrl=/admin" + to.fullPath;
        })
    } else {
        next()
    }
})
*/

export default router;